import React from 'react';
import { observer } from 'mobx-react';

import { ScreenStore } from '../../../stores/ScreenStore';
import { constants } from '../../../config';
import { Select } from '../../../common/select';
import { SearchStore } from '../../../stores/SearchStore';
import styles from './SortSelect.css';
import iconSort from './icon-sort.svg';

class SortSelect extends React.Component {
  static updateSort(value) {
    SearchStore.sort(value);
  }

  constructor(props) {
    super(props);
    this.optionLabels = {
      [SearchStore.sortOptions.RELEVANCE]: 'Más relevante',
      [SearchStore.sortOptions.PRICE_ASC]: 'Menor precio',
      [SearchStore.sortOptions.PRICE_DESC]: 'Mayor precio',
    };
    this.options = Object.keys(this.optionLabels).map(key => ({
      value: key,
      label: this.optionLabels[key],
    }));
  }

  render() {
    const showMobileVersion = ScreenStore.screenWidth <= constants.breakpoints.smallMaxWidth;
    const valueData = showMobileVersion ? <img src={iconSort} alt="sort" /> : this.optionLabels[SearchStore.selectedSortOrder];
    return (<Select
      rightAligned={showMobileVersion}
      dropdownClassName={styles.dropdown}
      onChange={SortSelect.updateSort}
      options={this.options}
      optionClassName={styles.option}
      selectedClassName={styles.selected}
      value={valueData}
      noIndicator={showMobileVersion}
    />);
  }
}

const ObservedSortSelect = observer(SortSelect);

export { ObservedSortSelect as SortSelect };



// WEBPACK FOOTER //
// ./src/pages/search/sort-select/SortSelect.jsx